import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/faculities/[id]/Components/HeaderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/faculities/[id]/Components/NavigationMenu.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/bgLinear.png");
